import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchBulkImportHistory } from './bulk-import.action';
import { Observable } from 'rxjs';
import { selectBulkImportHistory } from './bulk-import-selector';

@Injectable({ providedIn: 'root' })
export class BulkImportHistoryTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) {
        //Used Only If Multiselect Chcekbox Exist
        this.recordsList$ = this.store.select(selectBulkImportHistory);
    }
 
    pagination = [];
    filters = {
                created_at: '',
                import_type: null,
                first_name: '',
                is_imported: null,
                total_rows: '',
                total_failed_rows: '',
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    import_types = [
        {id: "1", value: "BULK_IMPORT.club-import"},
        {id: "2", value: "BULK_IMPORT.member-import"},
         {id: "3", value: "BULK_IMPORT.dossier-import"},
        {id: "4", value: "BULK_IMPORT.bulk-import"},
    ];

    import_status = [
        {id: "1", value: "BULK_IMPORT.pending"},
        {id: "2", value: "BULK_IMPORT.in-progress"},
        {id: "3", value: "BULK_IMPORT.completed"},
    ];

    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 170},
                { prop: 'import_type', name: 'BULK_IMPORT.import-type', sortable: true, hasFilter: true, filter: "select", options: 'import_types', options_id: "id", options_label: "value", widthSet: 170},
                { prop: 'first_name', name: 'BULK_IMPORT.imported-by', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'is_imported', name: 'BULK_IMPORT.status', sortable: true, hasFilter: true, filter: "select", options: 'import_status', options_id: "id", options_label: "value", widthSet: 170},
                { prop: 'total_rows', name: 'BULK_IMPORT.total-rows-count', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'total_failed_rows', name: 'BULK_IMPORT.failed-rows-count', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""}
            ];

    recordsList$: Observable<any>; //Used Only If Multiselect Chcekbox Exist

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchBulkImportHistory());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        

    }

    resetState(){
        this.filters = {
            created_at: '',
            import_type: null,
            first_name: '',
            is_imported: null,
            total_rows: '',
            total_failed_rows: '',
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;
    }

    resetFilters(){
        this.resetState();
        this.loadRecords();
    }

}